// extracted by mini-css-extract-plugin
module.exports = {"sweeperWrapper":"styles_sweeperWrapper__1AaOJ","slide":"styles_slide__2w-oI","controls":"styles_controls__x7RX0","arrowHolder":"styles_arrowHolder__2nEvW"};